export const showSearch = process.env.REACT_APP_HIDE_SEARCH?.valueOf() === 'true' ? false : true;
export const showLogin = process.env.REACT_APP_HIDE_LOGIN?.valueOf() === 'true' ? false : true;

